import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
// Inject the tt-auth cookie refresh script so the __ttauth cookie is
// silently renewed in the background before it expires.
//
// IMPORTANT: The script src must be same-origin as the page so that the
// SharedWorker inside init.js resolves its own URL relative to the page's
// origin (e.g. localhost:3000), not the backend (localhost:3001).
//
//   - In dev (localhost:3000):  /ttauth/v1/cookie/init.js  →  CRA proxy →
//                                localhost:3001 proxy → authservice-preprod
//   - In production (same origin): /ttauth/v1/cookie/init.js → Express proxy
//                                   → authservice-preprod
//
// Using window.location.origin ensures same-origin in both cases.
(function injectTtAuthInitScript() {
  const script = document.createElement('script');
  script.src = `${window.location.origin}/ttauth/v1/cookie/init.js`;
  script.async = true;
  script.onerror = () => console.warn('[INDEX] tt-auth init.js failed to load — cookie refresh disabled');
  document.head.appendChild(script);
  console.log('[INDEX] tt-auth init.js injected:', script.src);
})();

const queryClient = new QueryClient();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>
);

// Service worker has been permanently disabled to resolve caching issues.

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
